let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kWvsT")).then(() => parcelRequire('6fuMV'));